import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';

import copy from './CategoryRoomsCopy.json';
import styles from './CategoryRooms.scss';

export function CategoryRooms({ onClick }) {
    return (
        <Fragment>
            <div className={styles.roomHeader}>
                <FormattedMessage id="dbl.CategoryRooms.header" defaultMessage="Shop by Room" />
            </div>
            <div className={styles.roomList}>
                {copy.rooms.map(room => {
                    const imageStyle = { backgroundImage: `url("${room.imageUrl}")` };
                    return (
                        <div className={styles.room} key={room.url}>
                            <a
                                href={room.url}
                                className={styles.roomLink}
                                data-tn="category-room-tile-link"
                                onClick={e => onClick(e, { room })}
                            >
                                <div className={styles.roomTitle}>
                                    <FormattedMessage
                                        id="dbl.CategoryRooms.title"
                                        defaultMessage={`
                                            {type, select,
                                                dining {Dining Room}
                                                kitchen {Kitchen}
                                                living {Living Room}
                                                other {Bedroom}
                                            }
                                        `}
                                        values={{ type: room.type }}
                                    />
                                </div>
                                <div className={styles.roomImage} style={imageStyle} />
                            </a>
                        </div>
                    );
                })}
            </div>
        </Fragment>
    );
}

CategoryRooms.defaultProps = {
    onClick: () => {},
};

CategoryRooms.propTypes = {
    onClick: PropTypes.func,
};
